import cn from '@/lib/cs';
import React from 'react';

const CameraIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M24 6c-.1-.8-1.4-1.1-2-1-1.4.2-2.7 0-4 .1-.6-2-1.1-3-3.3-2.9-1.6.5-5 0-7 0-.8 0-1 1-1.3 1.9-.1.5-.3 1-.6 1.3a6 6 0 0 1-1.8 0C3 5.1.9 5.1.3 6c-.2.3-.2.6-.1 1 .2 3-.3 6 0 9 0 1.2.2 2.3.3 3.5 0 .6.3 1.3.9 1.3h7.4l2.6.1c2.4 0 4.7-.5 7.1-.3h1.2c1.3.2 2.8.4 3.6-.3 1-1 .6-3.6.6-4.8 0-3.2.2-6.4 0-9.6ZM2.4 11.4c0-1.3-.2-3.8.5-4h.1c3.7.2 4.3.2 4.5-.2.4-.7 0-1.5.8-2.3.8-1 5-.4 6.4-.6l.8.1c.4.4.6 1.3.6 1.8-.1.7.8 1.5 1.4 1.4 2-.2 4.3-.3 4.5 0a30 30 0 0 1-.5 11.1c-.6.6-2.9.1-3.5.1-4.1-.3-9.1.4-13.5 0l-2.4-.1v-1.3l.3-6Z"
		/>
		<path
			fill="currentColor"
			d="M16 13.4V12c-.1-3.2-3-4.4-5.5-3.6-1 .4-1.4 1.6-2 2.4-.5.6-.6 1.2-.4 2 .2.8.2 2.2 1 2.7 1.5 1.2 2.2 1.3 3.9 1.1 1.2-.2 3.2-2 3-3.3Zm-2.2.2c-.5.7-1.2.5-1.8.9-.6.4-1-.8-1.3-1.1-1-1.1 0-3 1.5-2.5 1.2.4 1.3.6 1.3 1.1 0 .4.5 1.2.3 1.6Z"
		/>
	</svg>
);

export default CameraIcon;
